import React from "react";

function PhoneIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="33"
            fill="none"
            viewBox="0 0 34 33"
        >
            <mask
                id="mask0_0_5197"
                style={{ maskType: "alpha" }}
                width="34"
                height="33"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path fill="#D9D9D9" d="M0.906 0H33.164V32.258H0.906z"></path>
            </mask>
            <g fill="#000" mask="url(#mask0_0_5197)">
                <path d="M25.896 13.713a.446.446 0 00.446-.445V6.734a.461.461 0 00-.01-.088c-.002-.012-.006-.023-.01-.035a.456.456 0 00-.014-.048c-.006-.014-.014-.026-.02-.039-.007-.012-.013-.026-.021-.038a.454.454 0 00-.046-.055l-.01-.012-.011-.01a.447.447 0 00-.056-.046l-.036-.019a.438.438 0 00-.041-.022.474.474 0 00-.043-.013c-.014-.004-.027-.01-.04-.012a.464.464 0 00-.076-.008h-6.545a.446.446 0 000 .89h5.457l-6.988 6.989a.446.446 0 00.63.63l6.989-6.988v5.457a.445.445 0 00.445.446z"></path>
                <path d="M27.34 21.256l-4.337-2.869a1.088 1.088 0 00-1.466.206l-1.294 1.684a1.122 1.122 0 01-.97.45c-1.376-.122-3.347-1.52-4.596-2.77-1.25-1.249-2.648-3.22-2.77-4.595a1.123 1.123 0 01.45-.97l1.684-1.295a1.088 1.088 0 00.206-1.466l-2.87-4.338a1.09 1.09 0 00-1.26-.389c-.432.16-.848.365-1.238.611a6.234 6.234 0 00-1.543 1.397c-3.025 3.85-1.638 9.51 3.62 14.767 5.257 5.257 10.916 6.644 14.766 3.62a6.235 6.235 0 002.008-2.782 1.09 1.09 0 00-.39-1.26zm-.458.946a5.714 5.714 0 01-.526 1.068 5.316 5.316 0 01-1.194 1.318c-3.46 2.718-8.66 1.358-13.567-3.55-4.907-4.907-6.267-10.106-3.549-13.566a5.318 5.318 0 011.317-1.193 5.71 5.71 0 011.069-.527.183.183 0 01.2.054l2.87 4.338a.184.184 0 01-.023.244l-1.673 1.286a2.006 2.006 0 00-.8 1.767c.142 1.61 1.624 3.75 3.03 5.156 1.408 1.406 3.548 2.889 5.156 3.03a2.006 2.006 0 001.768-.799l1.286-1.674a.184.184 0 01.244-.022l4.338 2.869a.174.174 0 01.064.139.184.184 0 01-.01.062z"></path>
            </g>
        </svg>
    );
}

export default PhoneIcon;
